import React, {useContext} from 'react';
import axios from 'axios';
import {Link} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import AuditContext from '../Utils/context.js';

export default function Proof() {

  const {schedule} = useContext(AuditContext);
  const [swal, setSwal] = useAlert(null);

  const getVariant = (form) => {

    switch (true) {
      case (form?.EVALUATE_AT !== null && form?.EVALUATE_BY !== null):
        return 'success';
      case (form?.SUBMIT_AT !== null && form?.SUBMIT_BY !== null):
        return 'primary';
      default:
        return 'secondary';
    }
  }

  const handleSendEmail = async () => {
    try {
      const onSuccessCallback = async () => {
        let formData = new FormData();
        formData.append('TYPE', 'EVALUATION_AUDIT');
        formData.append('EMAIL', JSON.parse(localStorage.getItem('authenticated')).employee.EMP_EMAIL);
        formData.append('SCHEDULE', schedule.SCHEDULE_ID);
        const response = await axios.post(`${process.env.REACT_APP_API_HOST}notification/send-email`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          }
        });
      }
      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Are you sure?`,
          message: `You are about to send Notification to Auditor Member.`,
          onSuccess: {
            title: `Success`,
            message: `Send Notification Success`,
            callback: onSuccessCallback,
          }
        }
      });
    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  return (
    <>
      {swal}
      <h3>Proof Submission</h3>
      {schedule.forms && schedule.forms.map((form, key) => {
        if (form.SUBMIT_BY === null) {
          return (
            <Link key={key} to={`/admin/proofs/${form.FORM_ID}`}>
              <Button variant={getVariant(form)}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
            </Link>
          );
        } else {
          return (
            <Link key={key} to={`/admin/evaluations/${form.FORM_ID}`}>
              <Button variant={getVariant(form)}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
            </Link>
          );
        }
      })}
      <div style={{marginTop: 20}}>
        {
          <Button type="button"  onClick={handleSendEmail} variant="danger">Send Notification</Button>
        }
      </div>
    </>
  )
}